<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content mgl-0 pd-40px">
        <div class="columns is-gapless is-multiline">
          <div class="column is-8">
            <h1 class="title is-size-3">
              {{ $t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.title')}}
            </h1>
          </div>
          <div class="column has-text-right is-size-6">
            {{ $t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.nbFacesSelect',
            { total: filteredFacesList.length })}}
          </div>
        </div>
       <div class="columns is-multiline is-align-items-end">
          <div class="column">
            <b-field :label="$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.reseau')">
              <qd-taginput v-model="reseauxSelected"
                          :data="filteredTags"
                          autocomplete
                          open-on-focus
                          field="libelleVisuelle"
                          type="is-primary"
                          @typing="getFilteredTags"
                          @remove="updateFacesSelect($event, false)"
                          @add="updateFacesSelect($event, true)"
                          >
              </qd-taginput>
            </b-field>
          </div>
          <div class="column is-narrow">
            <exportExcelButton
              :perm="constantes.CATALOGUE.exporter"
              :action="exporter"
              class="is-pulled-right"/>
          </div>
          <div class="overflow-auto height-500 column is-12"
              :class="[
                    { 'dispo': filtres.dispo === 'true' },
                    { 'nonDispo': filtres.dispo === 'false' },
                  ]">
            <v-client-table :data="filteredFacesList" :columns="columns" :options="options"
                            ref="tableListeFacesBaseSelected" @filter="changeFilter"
                            class="is-marginless vueTableSelectionFaces">
              <div slot="dispo" slot-scope="props">
                <div class="colonneDispo mg-auto"
                    :class="[{'has-background-danger' : !props.row.dispo},
                      {'has-background-success' : props.row.dispo}]">
                </div>
              </div>
              <div slot="reference" slot-scope="props">
                <router-link-blank :to="{ name: 'c.bodac.catalogue-face',
                    params: { id: props.row.produitId } }"
                                  :message="props.row.reference">
                </router-link-blank>
              </div>
              <div slot="adresse" slot-scope="props">
                {{ props.row.adresse | adresse}}
              </div>
              <div slot="reseauLibelle" slot-scope="props">
                {{ props.row.reseauLibelle}}
              </div>
              <div slot="dateDepart" slot-scope="props">
                {{ props.row.dateDepart }}
              </div>
              <div slot="ville" slot-scope="props">
                {{ props.row.ville }}
              </div>
              <div slot="codePostal" slot-scope="props">
                {{ props.row.codePostal }}
              </div>
              <div slot="affecteLogistiquement" slot-scope="props">
                <div v-if="displayLogistique(props.row)" class="has-text-centered">
                  <b-tooltip :active="!props.row.affecteLogistiquement"
                        :label="getDetailIndispo(props.row)" position="is-left">
                    <b-icon :icon="props.row.affecteLogistiquement
                            ? 'check-circle' : 'close-circle'"
                            size="mdi-24px"
                            :type="props.row.affecteLogistiquement ? 'is-success' : 'is-danger'">
                    </b-icon>
                  </b-tooltip>
                </div>
              </div>
            </v-client-table>
          </div>
        </div>
        <footer class="mgt-20px mgl-0">
          <b-field class="mgl-0">
            <div class="is-pulled-right boutonAction">
              <a class="button is-cancel btn-modal-annuler mgb-40px"
                 @click="$parent.close()">
                {{ $t('general.button.return') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { getLignesSelectionFace } from '@/services/dcf/reseauTempo/getListeFacesForSelection';
import messageErreur from '@/services/general/messageErreur';
import {
  RESULTS_PER_PAGE,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import exportListeFaces
  from '@/services/excel/exportFaceSelectInVenteTempoForReseauPerso/exportFaceSelectInVenteTempoForReseauPerso';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ligneReseauTempoOfReseauPerso: {
      type: Array,
      required: true,
    },
    displayColumnLogistique: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      listeFacesBase: [],
      listeReseauxTempo: [],
      filtres: {
        dispo: 'true',
        codePanneau: null,
        reference: null,
        format: null,
        adresse: null,
        ville: null,
        restriction: null,
        affecteLogistiquement: null,
        codePostal: null,
      },
      constantes: {
        CATALOGUE,
      },
      filteredTags: [],
      reseauxSelected: [],
    };
  },
  components: {
    routerLinkBlank,
    exportExcelButton,
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    affectationLogistiqueAlreadyDone() {
      return this.listeFacesBase.some((face) => { return face.affecteLogistiquement; });
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          codePanneau: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.panneau'),
          codeReseau: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.codeReseau'),
          reseauLibelle: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.reseauLibelle'),
          dateDepart: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.dateDepart'),
          dispo: '',
          reference: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.face'),
          format: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.format'),
          materielType: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.materielType'),
          adresse: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.adresse'),
          ville: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.ville'),
          restriction: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.restriction'),
          affecteLogistiquement: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.logistique'),
          codePostal: this.$t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.tab.codePostal'),
        },
        filterable: this.getFilterable,
        filterByColumn: true,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        listColumns: {
          dispo: [
            {
              id: true,
              text: this.$i18n.t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.dispo'),
            },
            {
              id: false,
              text: this.$i18n.t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.nonDispo'),
            },
          ],
          affecteLogistiquement: [
            {
              id: true,
              text: this.$i18n.t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.affecte'),
            },
            {
              id: false,
              text: this.$i18n.t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.nonAffecte'),
            },
          ],
        },
        texts: texts,
        filterAlgorithm: {
          dispo(row, query) {
            return row.dispo.toString() === query;
          },
        },
        columnsClasses: {
          selected: 'colonneSelected',
          dispo: 'colonneSelected',
          codePanneau: 'min-width-130',
          reference: 'min-width-130',
          restriction: 'min-width-130',
          format: 'min-width-130',
          affecteLogistiquement: 'min-width-130',
        },
        sortable: ['codePanneau', 'codeReseau', 'reseauLibelle', 'dateDepart', 'reference', 'format', 'materielType', 'adresse', 'ville', 'restriction', 'affecteLogistiquement', 'codePostal'],
      };
    },
    columns() {
      const columns = ['dispo', 'reference', 'codeReseau', 'reseauLibelle', 'dateDepart', 'codePanneau', 'format', 'materielType', 'adresse', 'codePostal', 'ville', 'restriction'];
      if (this.displayColumnLogistique) columns.push('affecteLogistiquement');
      return columns;
    },
    filteredFacesList() {
      return this.listeFacesBase.filter((face) => {
        let containFilter = true;
        const keys = Object.keys(this.filtres);
        keys.forEach((key) => {
          if (this.filtres[key]
            && !face[key].toString().toLowerCase()
              .includes(this.filtres[key].toLowerCase())) containFilter = false;
        });
        return containFilter && face.selected;
      });
    },
    getFilterable() {
      const columnsFiltered = ['dispo', 'codePanneau', 'codeReseau', 'reseauLibelle', 'dateDepart', 'reference', 'format', 'materielType', 'adresse', 'ville', 'restriction', 'codePostal'];
      if (this.displayColumnLogistique) columnsFiltered.push('affecteLogistiquement');
      return columnsFiltered;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    changeFilter(filter) {
      this.filtres[filter.name] = filter.value;
    },
    displayLogistique(ligne) {
      return (this.affectationLogistiqueAlreadyDone
        && (ligne.selected || ligne.affecteLogistiquement));
    },
    getFilteredTags(text) {
      this.filteredTags = this.listeReseauxTempo.filter((op) => {
        const isAdd = this.reseauxSelected
          .find(el => el.libelleVisuelle === op.libelleVisuelle);
        return op.libelleVisuelle
          .toString().toLowerCase()
          .indexOf(text.toLowerCase()) >= 0 && !isAdd;
      });
    },
    updateFacesSelect(reseau, selected) {
      this.listeFacesBase.forEach(face => {
        if (face.reseauLibelleFilter === reseau.libelleVisuelle) face.selected = selected;
      });
      this.filteredTags = this.listeReseauxTempo
        .filter(op => !this.reseauxSelected
          .map(el => el.libelleVisuelle)
          .includes(op.libelleVisuelle));
    },
    getDetailIndispo(ligne) {
      if (ligne.affecteLogistiquement) return '';
      if (!ligne.actif) {
        return this.$i18n.t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.indispo.inactif');
      }
      if (ligne.autreAffectationLogistique == null) {
        if (!ligne.aPatrimoine) {
          return this.$i18n.t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.indispo.sansPatrimoine');
        }
        return this.$i18n.t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.indispo.libre');
      }
      return this.$i18n.t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.indispo.dejaPris', { visuel: ligne.autreAffectationLogistique.affectationLogistiqueLigneCommandeLibelle });
    },
    getAnneeSemaine(anneeSemaine) {
      return this.$i18n.t('detail.popUpFaceSelectInReseauTempoOfReseauPerso.anneeSemaine', {
        week: anneeSemaine.toString().substring(4, 6),
        year: anneeSemaine.toString().substring(0, 4),
      });
    },
    exporter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const info = {
          affectationLogistiqueAlreadyDone: this.affectationLogistiqueAlreadyDone,
          displayColumnLogistique: this.displayColumnLogistique,
        };
        exportListeFaces(this.filteredFacesList, this.$i18n, info);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('exportExcelFaceSelect.messages.excelExportError'));
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      const users = this.parametre(PARAMETRES_KEYS.utilisateur);
      const promises = [];
      this.ligneReseauTempoOfReseauPerso.forEach(ligne => {
        promises.push(getLignesSelectionFace(
          ligne, false, users, this.societeActiveId,
        ));
      });
      let faces = await Promise.all(promises);
      this.ligneReseauTempoOfReseauPerso.forEach((ligne, index) => {
        const libelleReseauConcat = `${ligne.produit.libelle} - ${this.getAnneeSemaine(ligne.ligneReseau.anneeSemaine)}`;
        this.listeReseauxTempo.push({
          ...ligne.produit,
          libelleVisuelle: libelleReseauConcat,
        });
        faces[index].forEach(face => {
          face.codeReseau = ligne.produit.reference;
          face.reseauId = ligne.produitId;
          face.reseauLibelle = ligne.produit.libelle;
          face.reseauLibelleFilter = libelleReseauConcat;
          face.dateDepart = this.getAnneeSemaine(ligne.ligneReseau.anneeSemaine);
        });
      });
      faces = faces.flat();
      this.listeFacesBase = faces.sort((a, b) => {
        return a.affecteLogistiquement - b.affecteLogistiquement;
      });
      this.reseauxSelected = this.listeReseauxTempo;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
